module.exports = __webpack_public_path__ + "static/vesnicky-9158e7be5d9ab66507fdd1ab350f7c02.svg";